// /game-scoring/edit/<id>/matchups (views/web/game_scoring/_matchups.php): each
// matchup cell and division percent is its own form, saved by Enter.
const matchups = $('.league_battle_test');

if(matchups.length) {
	matchups.find('.score_penalty').each(function(i, penalty) {
		$(penalty).data('initial_value', $(penalty).val());
	});

	matchups.on('submit', '.league_interactions_form', function(e) {
		e.preventDefault();
		const form = $(this);
		const inputs = form.find(':input');
		inputs.addClass('saving');

		const revert = function() {
			form.find('.score_penalty').each(function(i, penalty) {
				$(penalty).val($(penalty).data('initial_value'));
			});
		};
		const finished = function() {
			inputs.removeClass('saving');
		};
		$.post(form.attr('action'), form.serializeArray()).then(function(response) {
			if(!response.success) {
				revert();
			}
			if(response.relationship) {
				form.find('.score_penalty.win').val(response.relationship.win_percent);
				form.find('.score_penalty.loss').val(response.relationship.lose_percent);
			}
			finished();
		}).fail(function() {
			revert();
			finished();
		});
	}).on('submit', '.division_percentage', function(e) {
		e.preventDefault();
		const form = $(this);
		const inputs = form.find(':input');
		inputs.addClass('saving');
		$.post(form.attr('action'), form.serializeArray()).always(function() {
			inputs.removeClass('saving');
		});
	});
}
